// Workstations.tsx
import React, { useState, useEffect } from 'react';
import Table from './components/Table/Table';
import { getWorkstationsByLocalId, deleteWorkstationById } from '../../../../crud/management_api/workstations';
import { Workstation } from '../types';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { TerminalOption, getTerminalOptions } from './components/Table/components/utils/utils';
import { MPPageTitle } from '../../../../components/ui';
import FilterBar from './components/FilterBar/FilterBar';
import { toast } from 'react-toastify';
import { getPermissionState } from '../../../../utils/functions';

const Workstations: React.FC = () => {
  const [workstations, setWorkstations] = useState<Workstation[]>([]);
  const [loading, setLoading] = useState(true);
  const [filteredWorkstation, setFilteredWorkstation] = useState<Workstation[]>([]);
  const [terminals, setTerminals] = useState<TerminalOption[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [showSelection, setShowSelection] = useState(false);
  const [selectedWorkstations, setSelectedWorkstations] = useState<Workstation[]>([]);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    const userContext = localStorage.getItem('user')
    const localId = userContext ? JSON.parse(userContext).local_id : 0
  
    Promise.all([
      getWorkstationsByLocalId(localId),
      getTerminalOptions()           
    ])
      .then(([wsResp, terminals]) => {
        setWorkstations(wsResp.data)
        setFilteredWorkstation(wsResp.data)
        setTerminals(terminals)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    if (searchValue.trim() === '') {
      setFilteredWorkstation(workstations);
    } else {
      const filtered = workstations.filter(workstation =>
        workstation.workstation_name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredWorkstation(filtered);
    }
  }, [searchValue, workstations]);

  const handleDeleteSelection = async () => {
    if (!selectedWorkstations.length) {
      toast.error('Selecciona al menos una estación');
      return;
    }
    try {
      const idsToDelete = selectedWorkstations.map((ws) => ws.workstation_id);
      await Promise.all(idsToDelete.map((id) => deleteWorkstationById(Number(id))));
      const newWorkstations = workstations.filter((w) => !idsToDelete.includes(w.workstation_id));
      setWorkstations(newWorkstations);
      setFilteredWorkstation(newWorkstations);
      setSelectedWorkstations([]);
      setShowSelection(false);
      toast.success('Estaciones eliminadas');
    } catch {
      toast.error('Error al eliminar estaciones');
    }
  };

  const handleSelectionToggle = () => {
    if (showSelection) {
      setSelectedWorkstations([]);
    }
    setShowSelection(!showSelection);
  };

  if (loading) {
    return <LoadingSpinner text='Cargando estaciones de trabajo...' transparent={true}/>;
  }

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle>Estaciones de trabajo</MPPageTitle>

      <FilterBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        showSelection={showSelection}
        selectedCount={selectedWorkstations.length}
        onCreateClick={() => setShowCreateModal(true)}
        onSelectionToggle={handleSelectionToggle}
        onDeleteSelection={handleDeleteSelection}
        canCreate={getPermissionState(44)}
      />
      <Table  
        data={filteredWorkstation} 
        terminals={terminals}
        setWorkstations={setWorkstations}
        setFilteredWorkstation={setFilteredWorkstation}
        externalShowSelection={showSelection}
        externalSelectedWorkstations={selectedWorkstations}
        externalSetSelectedWorkstations={setSelectedWorkstations}
        externalShowCreateModal={showCreateModal}
        externalSetShowCreateModal={setShowCreateModal}
      />
    </div>
  );
};

export default Workstations;
